import { Table } from "@tanstack/react-table";
import { cn } from "@theprelude/core";
import { CloseIcon, IconButton, Input, SearchIcon } from "@theprelude/ds";

export function TableFilterInput({
  className,
  table,
  onClose,
}: {
  className?: string;
  table: Table<any>;
  onClose?: () => void;
}) {
  const globalFilter = table.getState().globalFilter;
  return (
    <div className={cn("group w-full lg:w-96", className)}>
      <Input
        value={globalFilter ?? ""}
        onChange={(e) => {
          table.setGlobalFilter(e.target.value);
        }}
        autoFocus
        before={
          <SearchIcon className="text-secondary-foreground group-hover:text-primary-foreground" />
        }
        after={
          <IconButton
            icon={
              <CloseIcon className="text-secondary-foreground hover:text-primary-foreground" />
            }
            onClick={() => {
              table.setGlobalFilter("");
              onClose?.();
            }}
          />
        }
        placeholder="Search this view"
      />
    </div>
  );
}

export function SCMTableFilterInput({
  className,
  value,
  placeholder = "Search this view",
  onChange,
  onClear,
}: {
  className?: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onClear: (value: string) => void;
}) {
  return (
    <div className={cn("group w-full", className)}>
      <Input
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        autoFocus
        before={
          <SearchIcon className="text-secondary-foreground group-hover:text-primary-foreground" />
        }
        after={
          <IconButton
            icon={
              <CloseIcon className="text-secondary-foreground hover:text-primary-foreground" />
            }
            onClick={() => {
              onClear("");
            }}
          />
        }
        placeholder={placeholder}
      />
    </div>
  );
}
